import React from 'react'
import "./../styles/nComponents/trust.css"

import psstudio from "./../assets/sublogos/PSStudio.png"
import psdigit from "./../assets/sublogos/psdigital.png"
import psgzik from "./../assets/sublogos/PSGZik.png"
import afrijeune from "./../assets/sublogos/Afrijeunetv.png"

import psstudiomobile from "./../assets/low/sublogos/PSStudio.jpg";
import psdigitmobile from "./../assets/low/sublogos/psdigital.jpg";
import psgzikmobile from "./../assets/low/sublogos/PSGZik.jpg";
import afrijeunemobile from "./../assets/low/sublogos/Afrijeunetv.jpg";

function Trust() {
  return (
    <section className='trust-section'>
        <div className='container trusted-container'>
            <div className='trusted-by-container'>
                <div className='trusted-by-text'>
                    <span className='organization-span'>
                        Nos
                    </span>
                    Entreprises
                </div>
                <div className='clients-grid'>
                    <div className='trusted-by-grid-content'>
                        <div className=''>
                            <img
                                alt='trust'
                                className='client-logo'
                                src={psstudio}
                            />
                            <img
                                alt='trust'
                                className='client-log-mobile'
                                src={psstudiomobile}
                            />
                        </div>
                    </div>
                    <div className='trusted-by-grid-content'>
                        <div className=''>
                            <img
                                alt='trust'
                                className='client-logo'
                                src={psdigit}
                            />
                            <img
                                alt='trust'
                                className='client-log-mobile'
                                src={psdigitmobile}
                            />
                        </div>
                    </div>
                    <div className='trusted-by-grid-content'>
                        <div className=''>
                            <img
                                alt='trust'
                                className='client-logo'
                                src={psgzik}
                            />
                            <img
                                alt='trust'
                                className='client-log-mobile'
                                src={psgzikmobile}
                            />
                        </div>
                    </div>
                    <div className='trusted-by-grid-content'>
                        <div className=''>
                            <img
                                alt='trust'
                                className='client-logo afrijeune'
                                src={afrijeune}
                            />
                            <img
                                alt='trust'
                                className='client-log-mobile afrijeune'
                                src={afrijeunemobile}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Trust